import Report from "./Report";

export default {
  list: Report,
};
